import styled from "styled-components";
import { darken } from "polished";

import theme from "config/theme";

import { H4 } from "components/Text";
import StyledImage from "components/Image";

export const Wrapper = styled.a`
  display: block;
  margin-bottom: 20px;
  overflow: hidden;
  transition: ${theme.transition};
  border-radius: ${theme.radius};
  background-color: ${theme.color.paper2};

  @media (max-width: ${theme.size.mobile}) {
    margin-bottom: 10px;
  }

  &:hover {
    transform: scale(0.98) translateZ(0);
    background-color: ${darken(0.03, theme.color.paper2)};
  }
`;

export const Inner = styled.div`
  padding: 35px 30px 30px;
`;

export const Title = styled(H4)`
  line-height: 1.3;
  margin-bottom: 10px;
  font-size: ${theme.font.size.delta};
`;

export const Description = styled.div`
  margin-bottom: 25px;
  line-height: 1.6;
  color: ${theme.color.gray3};
  font-size: ${theme.font.size.zeta};
`;

export const Image = styled(StyledImage)`
  width: 100%;
  display: block;
`;

export const Date = styled.span`
  margin-top: 30px;
  display: table;
  cursor: pointer;
  color: ${theme.color.primary};
  font-size: ${theme.font.size.zeta};
`;
